package app.model

import app.plugin.ErrorMessages
import kotlinx.serialization.Serializable

@Serializable
data class Version(
    val prefix: String?,
    val major: Int,
    val minor: Int,
    val patch: Int,
    val suffix: String?,
) {
    companion object {
        fun parse(versionString: String): Version {
            val pattern = "(.+-)?(\\d+?).(\\d+?).(\\d+?)(-.+)?"
            val matchEntire = Regex(pattern).matchEntire(versionString)
                ?: error(ErrorMessages.INVALID_VERSION_STRING)
            val (prefix, major, minor, patch, suffix) = matchEntire.destructured
            return Version(
                prefix.takeIf { it.isNotEmpty() },
                major.toInt(),
                minor.toInt(),
                patch.toInt(),
                suffix.takeIf { it.isNotEmpty() }
            )
        }
    }

    override fun toString(): String = "${prefix?:""}$major.$minor.$patch${suffix?:""}"
}
